import { type FormMessages } from '@lingoda/utils';

export const gqlErrorsToToasts = (errors: FormMessages) => {
    return Object.entries(errors).map(([, payload]) => ({
        variant: 'error' as const,
        message: payload,
    }));
};
